import React from "react";
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import styled from 'styled-components';

import backgroundPic from "./images/headphones.jpg";
import PIC from "./images/Edttt.jpg";

import Footer from "./Footer"
import { Paper } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'start',
    color: "#FFF",
  },
  title: {
    flexGrow: 1,
    textAlign: 'start',
    color:"#FFF"
  },
  appBar:{
    background:"transparent",
    elevation:0
  },
  myTabs:{
    textAlign:"end",
    padding:20
  },
  tabButns:{
    border:"transparent",
    color:"#FFF"
  },
  headerBackground:{
    background: `url(${backgroundPic}) no-repeat`,
    backgroundSize: "cover",

  },
  textOnSlideShow:{
    textAlign:"center",
    width:"80%",
    color:"#FFF",
    alignContent:"center",
    alignItems:"center",
    
  }
 
}));


const StyledButton = styled.button`
color: white;
	padding: 5px;
	border: 1px;
	background: none;
  font-size: 1em;
  margin: 5px 10px 0px;

	&:hover {
		background: none;
    color: purple;
    cursor:pointer;
	}
`;

function About() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12} className={classes.headerBackground}>
          <AppBar position="static" className={classes.appBar}>
            <Toolbar>
              <Typography variant="h6" className={classes.title}>
                K-BRIELLY MUSIC
              </Typography>
            </Toolbar>
          </AppBar>
          <div className={classes.myTabs}>
            <StyledButton
              onClick={()=>{
                window.location.href="/"
              }}
              >
              HOME
            </StyledButton>
            <StyledButton
              onClick={()=>{
                window.location.href="/stream"
              }}
            >
              STREAM
            </StyledButton>
            <StyledButton
              onClick={()=>{
                window.location.href="/music"
              }}
            >
              MUSIC
            </StyledButton>
            <StyledButton
              onClick={()=>{
                window.location.href="/videos"
              }}
            >
              VIDEOS
            </StyledButton>
            <StyledButton
              onClick={()=>{
                window.location.href="/contacts"
              }}
            >
              CONTACT
            </StyledButton>
            <StyledButton
              onClick={()=>{
                window.location.href="/about"
              }}
            >
              ABOUT
            </StyledButton>
            <StyledButton
              onClick={()=>{
                window.location.href="/"
              }}
            >
              BLOG
            </StyledButton>
          </div>
          <hr></hr>
        </Grid>
        <Grid container justify="center" style={{background:"black",color:"#FFF",padding:20}}>
        <Grid item xs={4}>
              <Paper 
                style={
                  {background: `url(${PIC}) no-repeat`,
                  backgroundSize: "cover",
                  height:400,
                  }
              }>
              </Paper>
              <Paper style={{padding:20}} >
                <Grid item style={{textAlign:'start'}}>
                  <span style={{fontWeight:"bold"}}>
                    Born:
                    <span style={{fontWeight:"normal",padding:20,textAlign: 'center'}}>
                      Kagiso Brielly Mokgadi, Dec 22, 1995 (age 25), Lobatse, Botswana
                    </span><br/>
                  </span> 
                  <span style={{fontWeight:"bold"}}>
                    Occupation:
                    <span style={{fontWeight:"normal",padding:20,textAlign: 'center'}}>
                      Singer, songwriter, record producer, software engineer.
                    </span><br/>
                </span> 
                <span style={{fontWeight:"bold"}}>
                  Years active:
                  <span style={{fontWeight:"normal",padding:20,textAlign: 'center'}}>
                  2017–present.
                    </span><br/>
                </span> 
                <span style={{fontWeight:"bold"}}>
                  Genres:
                  <span style={{fontWeight:"normal",padding:20,textAlign: 'center'}}>
                    R&B/Soul, hip-hip, Trap, House
                    Instruments	Vocals.
                    </span><br/>
                  </span>
                </Grid>
              </Paper>
            </Grid>
            <Grid item xs={8}  className={classes.paper}>
              <h1 >K-Brielly</h1>
              Kagiso Brielly Mokgadi (born Dec 22, 1995) is a Motswana singer, rapper, songwriter, web developer and software engineer. Born in Lobatse, Botswana,
              he was always drawn to music and began writing his own songs from a young age. K-Brielly released his self-titled debut studio album in 2019 titled Conundrum,
              which consisted of his first self-produced song(Broken Soul) to be playlisted and aired on multiple national radio stations.
              <br/><br/>
              Since then K-Brielly believed in his ability to produce world standard records and so set up a small music studio to record and produce his music.
              Having the studio, K-Brielly released his second album (Conundrum 2) which is the second episode of the first album on all music platforms. He produced
              music for other artists and featured international acts such as Mark Wicked(Italian), Terror2x(USA), 24Inches(SA) and Pablo Rey(Spain).<br/><br/>

              K-Brielly Graduated with a University degree in 2020 from a local university, Botho University. He holds a
              BSc (Honors) in Mobile Computing.<br/><br/>
              <Typography className={classes.heading} style={{fontWeight:"bold",textAlign: 'center'}}>
                VISION AND MISSION
              </Typography>
              <p className={classes.paraphs}>
                "My mission as developer is to help bring about a change,
                contribute towards my country's economy and education. The
                modern world is centered around the new internet technologies
                which needs to be delivered to people out there to help better
                their lives. With the skills that i poses i will be able to do
                so. <br />
                With regards to music i aim at globalizing Botswana music.
                Taking it to the international level so that it can be
                appreciated and heard by foreign nations."
              </p>
            </Grid>
        </Grid>
          <Grid item xs={12} >
            <Footer/>
          </Grid>
      </Grid>
    </div> 
  );
}

export default About;
